import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactosPage.css';
import logo from '../../uploads/logotipo/SISGA.png'; // Importa el logo

const ContactosPage = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault(); 
    setStatusMessage('Enviando...');

    const serviceID = 'default_service';
    const templateID = 'template_e4q9t7h';
    const publicKey = 'QomQOH6-f60anHsEq';

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then((result) => {
          console.log(result.text);
          setStatusMessage('¡Mensaje enviado con éxito!');
          alert('¡Mensaje enviado con éxito!');
          form.current.reset();
      }, (error) => {
          console.log(error.text);
          setStatusMessage('Ocurrió un error al enviar. Por favor, intenta de nuevo.');
          alert('Ocurrió un error: ' + JSON.stringify(error));
      });
  };

  return (
    <div className="contactos-wrapper">
      <div className="contactos-container">
        {/* --- Columna del Formulario (sin campo Anexo) --- */}
        <div className="form-columna">
          <h2>Formulario Contacto / PQR</h2>
          <form ref={form} onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nombre">Nombre *</label>
              <input type="text" id="nombre" name="nombre" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="mensaje">Mensaje *</label>
              <textarea id="mensaje" name="mensaje" rows="6" required></textarea>
            </div>
            {/* El campo Anexo ha sido eliminado de aquí */}
            <button type="submit" className="submit-btn">Enviar Mensaje</button>
            {statusMessage && <p style={{ marginTop: '15px' }}>{statusMessage}</p>}
          </form>
        </div>

        {/* --- Columna de Información (SIN CAMBIOS) --- */}
        <div className="info-columna">
          <img src={logo} alt="Logo SISGA FR" className="logo-contacto" />
          <div className="info-section">
            <h3>Contacto General</h3>
            <ul>
              <li>
                <span className="info-icon">📧</span>
                <div>
                  <strong>Correo electrónico General</strong>
                  <a href="mailto:sisgafr@ryq.cl">sisgafr@ryq.cl</a>
                </div>
              </li>
              <li>
                <span className="info-icon">📧</span>
                <div>
                  <strong>Correo electrónico del Director</strong>
                  <a href="mailto:andres.castro@ryq.cl">andres.castro@ryq.cl</a>
                </div>
              </li>
              <li>
                <span className="info-icon">📞</span>
                <div>
                  <strong>Teléfono General</strong>
                  <span>601-5104988</span>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="info-section">
            <h3>Oficinas</h3>
            <ul>
              <li>
                <span className="info-icon">📍</span>
                <div>
                  <strong>Oficina Bogotá D.C.</strong>
                  <span>Carrera 13 No 37 – 43 Oficina 801. Edificio Cavipetrol</span>
                </div>
              </li>
              <li>
                <span className="info-icon">📍</span>
                <div>
                  <strong>Oficina Guateque</strong>
                  <span>Cra 6 #11-60 Segundo Piso</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactosPage;